var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:copy-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1219 4H7.21115C5.80578 4 4.6665 5.13928 4.6665 6.54464V16.4554C4.6665 17.8607 5.80578 19 7.21115 19H17.1219C18.5272 19 19.6665 17.8607 19.6665 16.4554V6.54464C19.6665 5.13928 18.5272 4 17.1219 4Z",
    stroke: "#4BB390",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6442 3.07143L16.6665 3.5C16.6646 2.83754 16.4006 2.20275 15.9322 1.73431C15.4638 1.26588 14.829 1.00188 14.1665 1H4.52365C3.76657 1.00224 3.04115 1.30398 2.50581 1.83931C1.97048 2.37464 1.66874 3.10007 1.6665 3.85714V13.5C1.66839 14.1625 1.93239 14.7973 2.40082 15.2657C2.86925 15.7341 3.50404 15.9981 4.1665 16H3.73793",
    stroke: "#4BB390",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGreen);
export default __webpack_public_path__ + "static/media/copy-green.d70b7b1bfd7ad7a08cb687631579e604.svg";
export { ForwardRef as ReactComponent };